export default "__VITE_ASSET__m07UGkmG__"